import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Badge } from '@/components/ui/badge'

import { useMasterAgents } from '@/hooks/master/useMasterAgents'

type MasterPanelProps = {
  enabled?: boolean
}

export function MasterAgentsPanel({ enabled = true }: MasterPanelProps) {
  const { agents, loading, error, refresh, available } = useMasterAgents({ enabled })
  const isUnavailable = enabled && !available

  return (
    <Card className="border border-border/70 bg-background/70">
      <CardHeader className="flex items-center justify-between gap-2">
        <CardTitle className="text-lg">Agent summary</CardTitle>
        <Badge variant="outline" className="text-xs">
          {agents.length}
        </Badge>
      </CardHeader>
      <CardContent className="space-y-2 text-sm">
        {error && !isUnavailable && <p className="text-xs text-rose-300">Unable to load agents</p>}
        {isUnavailable ? (
          <p className="text-xs text-muted-foreground">Master insights are unavailable in this environment.</p>
        ) : loading && agents.length === 0 ? (
          <p className="text-xs text-muted-foreground">Loading…</p>
        ) : agents.length === 0 ? (
          <p className="text-xs text-muted-foreground">No agents registered.</p>
        ) : (
          <ul className="space-y-2">
            {agents.map((agent) => (
              <li key={agent.agent} className="rounded-xl border border-border/80 bg-background/40 p-3">
                <div className="flex items-center justify-between gap-2">
                  <span className="text-foreground">{agent.agent}</span>
                  <Badge variant="secondary" className="text-xs uppercase">
                    {agent.workflow.state ?? 'idle'}
                  </Badge>
                </div>
                <p className="text-xs text-muted-foreground">
                  Tasks: {agent.open_tasks} · HITL: {agent.hitl_pending} · Events: {agent.event_count}
                </p>
              </li>
            ))}
          </ul>
        )}
        <button
          type="button"
          className="text-xs uppercase tracking-wide text-primary-foreground dark:text-amber-200 hover:underline disabled:opacity-50"
          onClick={() => refresh?.()}
          disabled={!available}
        >
          Refresh
        </button>
      </CardContent>
    </Card>
  )
}
